import { useState } from 'react';

const INITIAL_STATE = {
  polis: false,
  waiting: false,
  disease: false,
  kontestasi: false,
  claim: false,
};

const useCollapseTerms = () => {
  const [collapseTerm, setCollapseTerm] = useState(INITIAL_STATE);

  const toggleCollapseTerm = (section) => {
    setCollapseTerm((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return { collapseTerm, toggleCollapseTerm };
};

export default useCollapseTerms;
